// extracted by mini-css-extract-plugin
export default {"splashLogo":"App_splashLogo__UfPIA","splash":"App_splash__kYjwv"};